import { render } from "./PrintHeaderDesign2.vue?vue&type=template&id=07c3a3d3&scoped=true"
import script from "./PrintHeaderDesign2.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign2.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign2.vue?vue&type=style&index=0&id=07c3a3d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c3a3d3"]])

export default __exports__